class FacetReveal extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this?.els?.trigger?.exists) {
      this.toggleItems = this.toggleItems.bind(this)

      this.listeners.add(this.trigger, 'click', () => {
        this.toggleItems()
      })
    }
  }

  async toggleItems () {
    this.trigger.classList.toggle(this.trigger.dataset.activeClass)

    const currentButtonLabel = this.triggerText.textContent.trim()
    const newButtonLabel =
      currentButtonLabel === this.triggerText.dataset.more
        ? this.triggerText.dataset.less
        : this.triggerText.dataset.more
    this.triggerText.textContent = newButtonLabel

    this.els.item.elements.forEach((el) => {
      const currentAriaHidden = el.getAttribute('aria-hidden')
      const newAriaHidden = currentAriaHidden === 'true' ? 'false' : 'true'
      el.setAttribute('aria-hidden', newAriaHidden)
    })

    const storageName = this.trigger.dataset.storageName
    const storageValue =
      currentButtonLabel === this.triggerText.dataset.more ? 'true' : ''

    await window.BAO.Cart.updateCartAttributes({
      [storageName]: storageValue,
    })
  }

  get trigger () {
    return this.els.trigger.element
  }

  get triggerText () {
    return this.els['trigger-text'].element
  }
}

if (!customElements.get('facet-reveal')) {
  customElements.define('facet-reveal', FacetReveal)
}
